import React from 'react'
import RestaurantSelection from './RestaurantSelection';
import { useAuth } from '../contexts/AuthContext';
import { Button, FormControlLabel, Switch } from '@mui/material';
import { useCategory } from '../contexts/CategoryContext';

function PageHeader({ title, buttonLable, buttonOnClick, isSwitchVisible = false }) {
    const { auth } = useAuth();
    const { isDraggable, setIsDraggable } = useCategory()

    return (
        <div className='d-flex flex-row justify-content-between px-4 py-2 w-100 border-bottom'>
            <h4>{title}</h4>
            <div className='d-flex'>
                {
                    buttonLable && (
                        <Button
                            variant="outlined"
                            color='success'
                            type="submit"
                            onClick={buttonOnClick}
                        >
                            {buttonLable}
                        </Button>
                    )
                }
                {
                    isSwitchVisible && (
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isDraggable}
                                    onChange={(e) => setIsDraggable(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label="Enable Sorting"
                            labelPlacement="end"
                        />
                    )
                }
                {
                    auth.user && (
                        <RestaurantSelection
                            className='d-flex ms-3'
                            labelClassName='pt-2 me-2'
                            multiSelect={false}
                        />
                    )
                }
            </div>
        </div>
    )
}

export default PageHeader